const ENGINES = {
  TABLEEXPORT: 'tableexport',
  SHEETJS: 'sheetjs',
}

// ★ 切換引擎：改這一行就好
const ENGINE = ENGINES.SHEETJS

export default {
  ENGINES,
  engine: ENGINE,
  useSheetJS() {
    return ENGINE === ENGINES.SHEETJS
  },
}
